import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  PageViewPayload,
  logPageView as logPageViewAction,
  biModalUnload,
} from '../redux/actions';

/*
 * This hook helps firing a page view event from a modal when it loads.
 * Also, when the modal unloads, the hook signals the parent page to fire a new page view event,
 * thus restoring the bi context after the modal is closed.
 */
export function useBiLogModalPageView(modalLoadBiData: PageViewPayload) {
  const dispatch = useDispatch();
  const logPageView = useCallback(
    (payload: PageViewPayload) => dispatch(logPageViewAction(payload)),
    [dispatch]
  );

  // On component load, fire a page view event with the given payload.
  // On component unload, dispatch `biModalUnload`.
  useEffect(
    () => {
      logPageView(modalLoadBiData);

      return () => {
        dispatch(biModalUnload());
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    // return `logPageView` in case it's required to fire more page view events from the modal (e.g. in a wizard)
    logPageView,
  };
}
